import React, { useState, useRef, useEffect } from 'react';
import './CustomButtonDropdown.css'; // external CSS for styling
import { DownOutlined } from '@ant-design/icons'; // ✅ Import icon

const CustomButtonDropdown = ({ buttonLabel, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <button className="dropdown-button" onClick={toggleDropdown}>
        {buttonLabel} <DownOutlined style={{ fontSize: '10px' }} />
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          {options.map((opt, index) => (
            <div key={index} className="dropdown-item" onClick={opt.onClick}>
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomButtonDropdown;
